// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1PDDq","overflowing":"ReadFullNote_overflowing__3xYfA"};